import React from 'react';
import { useSidebar } from '@css-xp/base';
import { BillingAdmin, CommerceAddress, Maybe } from '@css-xp/graphtypes';
import AddBillingAdminsForm from './add-billing-admin-form';

interface AddBillingAdminsSidebarProps {
  transactionAccountId?: string;
  invoiceGroupId?: string;
  billingAdmins?: (BillingAdmin | undefined | null)[];
  billToAddress: Maybe<CommerceAddress>;
  onComplete: () => void;
  transactionAccountNumber?: string;
  isSubtextHidden?: boolean;
  sideBarClassName?: string;
  validDomains?: (string | null | undefined)[];
  isPartnerAccount?: boolean;
}
export const AddBillingAdminsSidebar = ({ ...props }: AddBillingAdminsSidebarProps) => {
  const { closeSidebar } = useSidebar();

  return <AddBillingAdminsForm {...props} onClose={closeSidebar} />;
};

export default AddBillingAdminsSidebar;
